import { useMilestoneTableSize } from './MilestoneTableSizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MilestoneTableColGroup = ({
  hasSuggestions = false
}) => {
  const size = useMilestoneTableSize();
  if (size === 'small') {
    return /*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {
        width: "40px"
      }), /*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
        width: hasSuggestions ? '96px' : '56px'
      })]
    });
  }
  return null;
};